class FreeShippingMeter extends HTMLElement {
    constructor() {
        super();
    }

    static thresholdCents = Math.round(Number(window.free_shipping_price) * 100);
    static rawVariantIds = new Set(window.gdc_shipping.raw_variant_ids);
    static classLabel1 = 'progress-30';
    static classLabel2 = 'progress-60';
    static classLabel3 = 'progress-100';

    connectedCallback() {
        this.freeShippingEligible = 0;
        this.progressBar = this.querySelector('[data-shipping-progress]');
        this.messageElement = this.querySelector('[data-shipping-message]');
        this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';
        this.shipVal = window.free_shipping_text.free_shipping_1;
        this.progressMeter = this.querySelector('[data-free-shipping-progress-meter]');

        this.addEventListener('change', this.onCartChange.bind(this));

        this.initialize();
    }

    initialize() {
        Shopify.getCart((cart) => {
            this.cart = cart;
            this.calculateProgress(cart);
        })
    }

    onCartChange(e) {
        this.initialize();
    }

    calculateProgress(cart) {
      const totalCents = Number(cart.total_price);
      const thresholdCents = FreeShippingMeter.thresholdCents;
      const items = Array.isArray(cart.items) ? cart.items : [];
      this.hasRawItems = items.some(item => FreeShippingMeter.rawVariantIds.has(String(item.variant_id || item.id)));
      this.hasEligibleItems = items.some(item => item.requires_shipping === true && !FreeShippingMeter.rawVariantIds.has(String(item.variant_id || item.id)));
      this.supportedCurrency = (cart.currency || window.gdc_shipping.currency) === 'USD';
      this.validAmounts = Number.isSafeInteger(totalCents) && totalCents >= 0 && Number.isSafeInteger(thresholdCents) && thresholdCents > 0;
      this.freeShippingEligible = this.validAmounts && this.supportedCurrency && this.hasEligibleItems && totalCents >= thresholdCents ? 1 : 0;
      this.shipVal = this.freeShippingEligible ? window.free_shipping_text.free_shipping_1 : window.free_shipping_text.free_shipping_2;
      const showProgress = this.validAmounts && this.supportedCurrency && this.hasEligibleItems && totalCents > 0;
      const freeShipBar = showProgress ? Math.min(100, Math.max(0, totalCents * 100 / thresholdCents)) : 0;
      this.progressBar?.classList.toggle('progress-hidden', !showProgress);
      const text = this.getText(totalCents);
      const classLabel = this.freeShippingEligible ? 'progress-free' : this.getClassLabel(Math.min(freeShipBar, 99.99));
      this.setProgressWidthAndText(freeShipBar, text, classLabel);
    }
    
    getText(totalCents) {
      const strings = window.gdc_shipping;
      if (this.hasRawItems && !this.hasEligibleItems) return '<span>' + strings.raw_only + '</span>';
      if (!this.validAmounts || !this.supportedCurrency) return '<span>' + strings.exclusions + '</span>';
      let text;
      if (this.freeShippingEligible) {
        text = strings.qualified;
      } else if (this.hasEligibleItems && totalCents > 0) {
        const remainingCents = Math.max(0, FreeShippingMeter.thresholdCents - totalCents);
        text = strings.remaining.replace('[amount]', Shopify.formatMoney(remainingCents, window.money_format));
      } else {
        text = strings.empty.replace('[amount]', Shopify.formatMoney(FreeShippingMeter.thresholdCents, window.money_format));
      }
      return '<span>' + text + ' ' + strings.exclusions + '</span>';
    }

    getClassLabel(freeShipBar) {
        let classLabel;

        if (freeShipBar === 0) {
            classLabel = 'none';
        } else if (freeShipBar <= 30) {
            classLabel = FreeShippingMeter.classLabel1;
        } else  if (freeShipBar <= 60) {
            classLabel = FreeShippingMeter.classLabel2;
        } else if (freeShipBar < 100) {
            classLabel = FreeShippingMeter.classLabel3;
        } else {
            classLabel = 'progress-free'
        }

        return classLabel;
    }
    
    resetProgressClass(classLabel) {
        this.progressBar.classList.remove('none');
        this.progressBar.classList.remove('progress-30');
        this.progressBar.classList.remove('progress-60');
        this.progressBar.classList.remove('progress-100');
        this.progressBar.classList.remove('progress-free');

        this.progressBar.classList.add(classLabel);
    }
    
    setProgressWidthAndText(freeShipBar, text, classLabel) {
        setTimeout(() => {
            if (!this.progressBar || !this.messageElement) return;

            this.resetProgressClass(classLabel);

            if (this.progressMeter) {
                this.progressMeter.style.width = `${freeShipBar}%`;
                const textWrapper = this.progressMeter.querySelector('.text');
                if (this.textEnabled && textWrapper) textWrapper.textContent = `${freeShipBar.toFixed(2)}%`;
            }

            this.messageElement.innerHTML = text;

            if ((window.show_multiple_currencies && typeof Currency != 'undefined' && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
                Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
            }
        }, 400)
    }
}

window.addEventListener('load', () => {
    customElements.define('free-shipping-component', FreeShippingMeter);
})